module.exports = require('./helpers/bundle-url').getBundleURL('bCgob') + "logo-dark.eefe0b7f.svg";